'use client'

import * as React from 'react'

import { popupEventName } from '@/lib/popups/constants'
import type { SitePopup } from '@/lib/popups/types'

import { resolveTemplate } from './templates'
import { visitorCountry } from './visitor-country'

// Client island for the popup_inline story blok: renders a popup's template
// flat in the article body instead of in a floating frame. No triggers, caps
// or cooldowns apply — placement is the editor's choice — and there is no
// frame chrome, so `onCtaClick` is a no-op and no `onDismiss` is passed
// (templates hide their close/decline affordances on inline reasons).
export const PopupInline = ({ popup, preview }: { popup: SitePopup; preview: boolean }) => {
  // 'inline-preview' until proven live: recording and analytics stay off
  // during SSR/hydration, in draft mode, and inside the Storyblok editor
  // iframe (same guard as the SitePopups controller).
  const [reason, setReason] = React.useState('inline-preview')
  const [country, setCountry] = React.useState<string | null>(null)

  React.useEffect(() => {
    setCountry(visitorCountry())
    if (!preview && window === window.parent) {
      setReason('inline')
    }
  }, [preview])

  const Template = resolveTemplate(popup.kind, popup.template)

  // The declarative impression observer fires popup-<slug>--impression once
  // the embed scrolls into view — same event and property shape as a shown
  // popup, so the admin performance panel counts inline embeds too. The
  // attributes appear only once live; the engine's MutationObserver picks
  // them up post-hydration.
  const impressionProps =
    reason === 'inline'
      ? {
          'data-track-impression': true,
          'data-event-name': popupEventName(popup.slug),
          'data-slug': popup.slug,
          'data-kind': popup.kind,
          'data-template': popup.template,
          'data-reason': 'inline',
        }
      : {}

  return (
    <div {...impressionProps}>
      <Template popup={popup} country={country} onCtaClick={() => {}} reason={reason} />
    </div>
  )
}
